// Enumerations
import { UploadIdDocumentsEnumeration } from 'containers/upload-id/enumerations/upload-id-documents.enumeration';
// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.uploadIdContainer.landing.';

const CONDITION_01 = {
    [UploadIdDocumentsEnumeration.DNI]: `${DOMAIN}dniCondition01`,
    [UploadIdDocumentsEnumeration.NIE_PASSPORT]: `${DOMAIN}niePassportCondition01`,
    [UploadIdDocumentsEnumeration.NIE]: `${DOMAIN}nieCondition01`,
  },
  CONDITION_02 = {
    [UploadIdDocumentsEnumeration.DNI]: `${DOMAIN}dniCondition02`,
    [UploadIdDocumentsEnumeration.NIE_PASSPORT]: `${DOMAIN}niePassportCondition02`,
    [UploadIdDocumentsEnumeration.NIE]: `${DOMAIN}nieCondition02`,
  },
  CONDITION_03 = {
    [UploadIdDocumentsEnumeration.DNI]: `${DOMAIN}dniCondition03`,
    [UploadIdDocumentsEnumeration.NIE_PASSPORT]: `${DOMAIN}niePassportCondition03`,
    [UploadIdDocumentsEnumeration.NIE]: `${DOMAIN}nieCondition03`,
  },
  CONDITION_04 = {
    [UploadIdDocumentsEnumeration.DNI]: `${DOMAIN}dniCondition04`,
    [UploadIdDocumentsEnumeration.NIE_PASSPORT]: `${DOMAIN}niePassportCondition04`,
    [UploadIdDocumentsEnumeration.NIE]: `${DOMAIN}nieCondition04`,
  },
  DESCRIPTIONS = {
    [UploadIdDocumentsEnumeration.DNI]: `${DOMAIN}descriptionDni`,
    [UploadIdDocumentsEnumeration.NIE_PASSPORT]: `${DOMAIN}descriptionPassport`,
    [UploadIdDocumentsEnumeration.NIE]: `${DOMAIN}descriptionNie`,
  },
  DOCUMENTS = {
    [UploadIdDocumentsEnumeration.DNI]: `${DOMAIN}documentNameDni`,
    [UploadIdDocumentsEnumeration.NIE_PASSPORT]: `${DOMAIN}documentNamePassport`,
    [UploadIdDocumentsEnumeration.NIE]: `${DOMAIN}documentNameNie`,
  };

export { CONDITION_01, CONDITION_02, CONDITION_03, CONDITION_04, DESCRIPTIONS, DOCUMENTS };
